module.exports = __webpack_public_path__ + "img/placeholder.3834bcf3.webp";